import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
    >
      <Circle
        cx={30}
        cy={30}
        r={28.5}
        fill="#F2B914"
        stroke="#000"
        strokeWidth={3}
      />
      <Path
        d="M33.126 16.546l-.572 17.661h-5.108l-.572-17.662h6.252zM29.994 42.36c-.887 0-1.65-.314-2.287-.944a3.115 3.115 0 01-.945-2.287c0-.878.315-1.628.945-2.25.638-.63 1.4-.944 2.287-.944.853 0 1.603.314 2.25.944.654.622.981 1.372.981 2.25 0 .596-.153 1.14-.46 1.628a3.39 3.39 0 01-1.18 1.168 3.02 3.02 0 01-1.591.435z"
        fill="#000"
      />
    </Svg>
  )
}

export default SvgComponent
